define("Ames.InventoryOverride.InventoryOverride", [
  "underscore",
  "ProductLine.Stock.View",
  "Cart.AddToCart.Button.View",
  "ProductDetails.Quantity.View",
], function (_, StockView, AddToCartView, QuantityView) {
  "use strict";

  // Returns the trimmed Out of Stock Message, or null when empty/unset.
  // Any non-empty message means the item is OOS — the text itself is
  // whatever should render on the PDP ('Out Of Stock', 'Special Order
  // 2-3 Weeks', an ETA, etc.)
  function getSageOOSMessage(itemInfo) {
    var raw = itemInfo && itemInfo.outofstockmessage;
    if (raw == null || String(raw).trim() === "") return null;
    return String(raw).trim();
  }

  function itemInfoFromModel(model) {
    if (!model) return null;
    var item = (model.get && model.get("item")) || model;
    return item && item.attributes ? item.attributes : item;
  }

  // True when the item's Out Of Stock Behavior allows back orders
  // ("Allow back orders but display out-of-stock message" / ENABLE, or
  // "Allow back orders with no out-of-stock message" / NOMSG). Such items keep
  // Add to Cart + quantity even when an OOS message is shown, same as AW.
  // "- Default -", "Disallow back orders..." and "Remove item..." keep the
  // existing behavior (message shown, purchase controls hidden).
  function allowsBackOrders(itemInfo) {
    var raw = itemInfo && itemInfo.outofstockbehavior;
    if (raw == null) return false;
    var value = String(raw).trim();
    if (value === "ENABLE" || value === "NOMSG") return true;
    return /^allow back orders/i.test(value);
  }

  // OOS message that should also block purchasing
  function getBlockingOOSMessage(itemInfo) {
    var msg = getSageOOSMessage(itemInfo);
    return msg && !allowsBackOrders(itemInfo) ? msg : null;
  }

  return {
    mountToApp: function (container) {
      StockView.prototype.getContext = _.wrap(
        StockView.prototype.getContext,
        function (fn) {
          var context = fn.apply(this, _.rest(arguments));
          var msg = getSageOOSMessage(itemInfoFromModel(this.model));
          context.sageStockStatus = msg ? "outofstock" : "";
          context.sageStockMessage = msg || "";
          return context;
        },
      );

      AddToCartView.prototype.getContext = _.wrap(
        AddToCartView.prototype.getContext,
        function (fn) {
          var context = fn.apply(this, _.rest(arguments));
          if (getBlockingOOSMessage(itemInfoFromModel(this.model))) {
            context.isCurrentItemPurchasable = false;
          }
          return context;
        },
      );

      QuantityView.prototype.getContext = _.wrap(
        QuantityView.prototype.getContext,
        function (fn) {
          var context = fn.apply(this, _.rest(arguments));
          if (getBlockingOOSMessage(itemInfoFromModel(this.model))) {
            context.showQuantity = false;
            context.isReadOnly = true;
          }
          return context;
        },
      );
    },
  };
});
